import { useEffect, useRef } from 'react';
export function useEventListener(eventType, handler, element = window) {
    const savedHandler = useRef(handler);
    useEffect(function updateHandler() {
        savedHandler.current = handler;
    }, [handler]);
    useEffect(function registerHandler() {
        if (!element) {
            return;
        }
        const eventListener = (event) => {
            savedHandler.current(event);
        };
        element.addEventListener(eventType, eventListener);
        return () => {
            element.removeEventListener(eventType, eventListener);
        };
    }, [eventType, element]);
}
export default useEventListener;
